import { useSyncExternalStore } from 'react';

export type FontFaceSetLike = {
  check(font: string): boolean;
  load(font: string): Promise<FontFace[]>;
};

type FontStore = {
  loaded: boolean;
  listeners: Set<() => void>;
};

const stores = new Map<string, FontStore>();

function getOrCreateStore(fontFace: string, fonts: FontFaceSetLike): FontStore {
  const existing = stores.get(fontFace);
  if (existing) {
    return existing;
  }

  const store: FontStore = {
    loaded: fonts.check(fontFace),
    listeners: new Set(),
  };
  stores.set(fontFace, store);

  if (!store.loaded) {
    void fonts.load(fontFace).then(() => {
      store.loaded = true;
      for (const listener of store.listeners) {
        listener();
      }
    });
  }

  return store;
}

export function useFontReady(
  fontFace: string,
  fonts: FontFaceSetLike = document.fonts
): boolean {
  const store = getOrCreateStore(fontFace, fonts);
  return useSyncExternalStore(
    (callback) => {
      store.listeners.add(callback);
      return () => {
        store.listeners.delete(callback);
      };
    },
    () => store.loaded
  );
}
